export const template = {
  lead: [
    ["name", "phone", "gender", "email", "status"],
    ["nguyen van a", "0334461239", "Nam", "email@gmail.com", "Mới"],
    ["nguyen van b", "0334461240", "Nữ", "email2@gmail.com", "Mới"],
    ["nguyen van c", "0334461241", "Nam", "email3@gmail.com", "Mới"],
    ["nguyen van d", "0334461242", "Khác", "email4@gmail.com", "Mới"],
  ],
  question: [
    ["content", "A", "B", "C", "D", "correctAnswer", "category"],
    [
      "cau hoi 1",
      "A. dap an A",
      "B. dap an B",
      "C. dap an C",
      "D. dap an D",
      "A",
      "GOD98BARqD",
    ],
  ],
};
